<template>
    <div>
        <el-dialog :title="$tx('hygl.components.meetingDetail', '会议详情')" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" :before-close="handleClose">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="$tx('hygl.components.meetingInfo', '会议信息')" name="first">
                    <el-form :model="vo">
                        <div class="el-table el-table--fit el-table--border">
                            <div class="el-table__body-wrapper">
                                <table cellspacing="0" cellpadding="0" class="el-table__body">
                                    <tbody>
                                        <tr>
                                            <td v-field-lbl="'flSubject'" class="el-table__cell tdlbl tdw17" colspan="1">会议主题</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flSubject }}</span>
                                            </td>
                                            <td v-field-lbl="'meetingName'" class="el-table__cell tdlbl tdw17" colspan="1">会议室名称</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.meetPlace }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'startTime'" class="el-table__cell tdlbl tdw17" colspan="1">开始时间</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.startTime }}</span>
                                            </td>
                                            <td v-field-lbl="'endTime'" class="el-table__cell tdlbl tdw17" colspan="1">结束时间</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.endTime }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'flCreator'" class="el-table__cell tdlbl tdw17" colspan="1">召集人</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreator }}</span>
                                            </td>
                                            <td v-field-lbl="'flCreateDept'" class="el-table__cell tdlbl tdw17" colspan="1">召集部门</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreateDept }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-text-lbl="'phone'" class="el-table__cell tdlbl tdw17" colspan="1">联系电话</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreatorPhone }}</span>
                                            </td>
                                            <td v-field-lbl="'meetHost'" class="el-table__cell tdlbl tdw17" colspan="1">会议主持人</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.meetHost }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'attendLeader'" class="el-table__cell tdlbl tdw17" colspan="1">出席领导</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <span>{{ vo.attendLeader }}</span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td ref="tdlbl_会议主题" v-field-lbl="'flContent'" class="el-table__cell tdlbl tdw17" colspan="1">会议内容</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <span>{{ vo.flContent }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td ref="tdlbl_会议主题" v-field-lbl="'meetingAttach'" class="el-table__cell tdlbl tdw17" colspan="1">会议附件</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <div v-for="item in attachs" :key="item">
                                                    <span class="hoverSpan" style="cursor: pointer; color: #409efe" @click="downloadFuc(item.id)">{{ item.fileName }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetingAgenda', '会议议题')" name="second">
                    <!-- <p style="width: 96%; margin: 0 2%;"><span style="float: left;margin-bottom:10px ;">会议议题</span></p> -->
                    <el-table border :data="tableData" style="margin-bottom: 20px" height="300px" @row-click="rowClick">
                        <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                        <el-table-column :label="$tx('hygl.components.topics', '议题')" align="left" prop="flSubject" />
                        <el-table-column :label="$tx('hygl.components.reporter', '汇报人')" align="left" width="80" prop="flCreator" />
                        <el-table-column :label="$tx('hygl.components.reportTime', '汇报时长(分钟)')" align="center" width="110" prop="reportTime" />
                        <el-table-column :label="$tx('hygl.components.durationTime', '讨论时长(分钟)')" align="center" width="110" prop="talkTime" />
                        <el-table-column :label="$tx('hygl.components.attendees', '列席人员')" align="left" width="110" prop="attendStoolName" />
                        <el-table-column :label="$tx('hygl.components.attachNum', '附件数量')" width="65" align="center">
                            <template #default="scope">
                                <span style="cursor: pointer" @click="downloadFucYt(scope.row.id, scope.row.passenger.ytNum)">{{ scope.row.passenger.ytNum }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetinger', '会议人员')" name="third" class="hyryBox">
                    <p style="width: 96%; margin: 0 2%">
                        <el-button v-text-lbl="'addMeetingPerson'" size="small" :disabled="transTime(resultobj.startTime, resultobj.endTime) === '未开始' ? false : true" style="float: right; margin-bottom: 10px" @click="innerVisibleclick">添加参会人员</el-button>
                    </p>
                    <el-table v-model="tableDataPeople" border :data="tableDataPeople" style="margin-bottom: 20px" height="300px">
                        <!-- style="width: 96%;margin: 0 2%;height: 310px;overflow: hidden;overflow-y: auto;" -->
                        <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                        <el-table-column :label="$tx('fields.name', '姓名')" align="left" prop="userName" />
                        <el-table-column :label="$tx('hygl.components.duties', '职务')" width="100" align="left" prop="userPost" />
                        <el-table-column :label="$tx('hygl.components.depart', '部门')" width="100" align="left" prop="userDept" />
                        <el-table-column :label="$tx('hygl.components.phone', '联系电话')" width="100" align="center" prop="phone" />
                        <el-table-column :label="$tx('hygl.components.personType', '人员类型')" width="100" align="center" prop="meetPersonType">
                            <template #default="scope">
                                <span v-if="scope.row.meetPersonType === 1" v-text-lbl="'insider'">内部人员</span>
                                <span v-if="scope.row.meetPersonType === 2" v-text-lbl="'outsiders'">外部人员</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$tx('fields.remark', '备注')" align="left" width="100" prop="remark" />

                        <el-table-column v-if="transTime(resultobj.startTime, resultobj.endTime) === '未开始'" :label="$tx('pageBtns.operate', '操作')" width="65" align="center">
                            <template #default="scope">
                                <span v-pageBtn-lbl="'del'" style="cursor: pointer; color: #409efe" font-size="20px" @click="delChecked(scope.$index, scope.row)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-dialog width="600px" :title="$tx('hygl.components.participants', '参会人员')" :visible.sync="innerVisible" append-to-body>
                        <el-form :model="voPeople">
                            <div class="el-table el-table--fit el-table--border">
                                <div class="el-table__body-wrapper">
                                    <table cellspacing="0" cellpadding="0" style="border: 1px solid #ebeef5" class="el-table__body">
                                        <tbody>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-text-lbl="'personType'">类型</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员类型" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-radio-group v-model="meetPersonType" @change="addObjchange">
                                                                <el-radio v-text-lbl="'insider'" :label="'1'">内部人员</el-radio>
                                                                <el-radio v-text-lbl="'outsiders'" :label="'2'">外部人员</el-radio>
                                                            </el-radio-group>
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-field-lbl="'name'">姓名</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <ValidationProvider v-if="meetPersonType !== null" ref="ValidationProvider" v-slot="{ errors }" name="姓名" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-input v-if="meetPersonType == '1'" v-model="addObj.userName" v-select-dialog="'staff'" readonly :row="2" :root-org-code="vo.orgCode" :org-id="bumenid" :placeholder="$tx('hygl.components.orgPlaceholder', '请选择机构员工')" name="orgStaff" resize="none" />
                                                            <el-input v-if="meetPersonType == '2'" v-model="addObj.userName" :placeholder="$tx('hygl.components.namePlaceholder', '请输入姓名')" @change="renyuanshuru" />
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-text-lbl="'depart'">部门</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <ValidationProvider v-if="addObj.userDept !== null" ref="ValidationProvider" v-slot="{ errors }" name="userDept">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-input v-model="addObj.userDept" :readonly="meetPersonType === '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.departPlaceholder', '请输入部门')" @change="bumen" />
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-text-lbl="'telphone'">电话</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <ValidationProvider v-if="addObj.phone !== null" ref="ValidationProvider" v-slot="{ errors }" name="phone">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-input v-model="addObj.phone" :readonly="meetPersonType === '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.telphonePlaceholder', '请输入电话')" @change="dianhua" />
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required"></span>
                                                    <span v-text-lbl="'position'">职位</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <el-input v-model="addObj.userPost" :readonly="meetPersonType === '1'" :placeholder="meetPersonType === '1' ? $tx('hygl.components.autoGet', '自动获取') : $tx('hygl.components.positionPlaceholder', '请输入职位')" @change="zhiwei" />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required"></span>
                                                    <span v-text-lbl="'remark'">备注</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <el-input v-model="addObj.remark" :rows="2" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button v-pageBtn-lbl="'cancel'" @click="closeclick">取消</el-button>
                            <el-button v-pageBtn-lbl="'save'" type="primary" @click="savePeopleFuc">保 存</el-button>
                        </span>
                    </el-dialog>
                    <!-- </el-table> -->
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetingMinutes', '会议记录')" name="fourth">
                    <div style="width: 100%; height: 350px; padding: 10px; overflow: hidden; overflow-y: hidden; border: 1px solid rgb(235, 238, 245)">{{ vo.meetRecord === null ? $tx('hygl.components.noRecord', '暂无记录') : vo.meetRecord }}</div>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" icon="el-icon-close" @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 点击会议议题 -->
        <el-dialog v-if="ytisShow" v-el-drag-dialog title="附件" :visible.sync="ytisShow" :close-on-click-modal="false" width="1000px">
            <el-table border :data="listData" style="margin-bottom: 20px; cursor: pointer" @row-click="rowClickyiti">
                <!-- :row-class-name="tableRowClassName" -->
                <!-- :on-cell-click="rowClick" -->
                <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                <!-- <el-table-column
          :label="$tx('hygl.components.fileName2')"
          align="left"
          prop="fileName"
        /> -->
                <el-table-column :label="$tx('hygl.components.fileName2', '文件名称')" align="left">
                    <template slot-scope="scope">
                        <div style="color: #409eff">{{ scope.row.fileName }}</div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" icon="el-icon-close" @click="ytisShow = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    filters: {
        meetPersonTypefilter(val) {
            if (val === 1) {
                return '内部人员'
            } else if (val === 2) {
                return '外部人员'
            }
        }
    },
    components: {},
    props: {},
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            activeName: 'first',
            attachs: null,
            tableData: [],
            tableDataPeople: [],
            dialogVisible: false,
            vo: {},
            meetingId: '',
            radio: 1,
            innerVisible: false,
            options: [
                {
                    value: '1',
                    label: '参会人员'
                },
                {
                    value: '2',
                    label: '联络员'
                }
            ],
            peopleIds: '',
            value: '',
            resultobj: {},
            meetPersonType: '1',
            addObj: {
                regStatus: 1,
                remark: '',
                email: '',
                phone: '',
                passenger: {},
                personId: '',
                userAccount: ''
            },
            disableds1: false,
            disableds2: false,
            disableds3: false,
            ytisShow: false,
            readonlys: false,

            rules: {
                phone: [
                    { required: true, message: this.$tx('hygl.components.rulePhone', '电话不能为空'), trigger: 'blur' },
                    { type: 'number', message: this.$tx('hygl.components.ruleGs', '请输入正确格式电话'), trigger: 'blur' },
                    { min: 11, max: 11, message: this.$tx('hygl.components.ruleFormat', '请输入11位手机号'), trigger: 'blur' }
                ]
            },
            bumenid: ''
        }
    },
    computed: {},
    watch: {
        meetPersonType(val) {
            this.addObj = {
                regStatus: 1,
                remark: '',
                email: '',
                passenger: {},
                personId: '',
                userAccount: ''
            }
        },
        innerVisible(val) {
            if (!val) {
                this.addObj = {}
                this.bumenid = ''
            }
        }
    },
    created() {},
    beforeDestroy() {
        this.$bus.$off('clicklog')
    },
    mounted() {
        console.log('kanren', this.loginUser)
        this.$bus.$on('clicklog', (resultobj) => {
            this.resultobj = resultobj
            this.activeName = 'first'
            this.dialogVisible = true
            this.meetingId = resultobj.id
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    busiDataIds: resultobj.id
                },
                url: '/hygl/attach/queryAttachList'
            }).then((result) => {
                if (result.code === 'success') {
                    this.attachs = result.body.listdata
                    console.log(this.attachs)
                } else {
                    this.$message.error(result.message)
                }
            })
            this.vo = {}
            this.initGetById(resultobj.id)
        })
    },
    methods: {
        transTime(start, end) {
            var date = new Date()

            var startTime = new Date(start)
            var endTime = new Date(end)
            if (startTime > date) {
                return '未开始'
            } else if (endTime < date) {
                return '已结束'
            } else if (startTime < date) {
                return '进行中'
            }
        },
        tableRowClassName({ row, rowIndex }) {
            console.log(23457, row, rowIndex)
            return 'warning-row'
        },
        onSelectTreeDataLoaded: function (treedata, attr) {
            var newTree = []
            treedata.forEach((item) => {
                if (this.peopleIds.indexOf(item.personId) === -1) {
                    newTree.push(item)
                }
            })
            treedata = newTree
            return treedata
        },
        async innerVisibleclick() {
            this.innerVisible = true
            const arr = []
            // 对一人多个部门选出当前登录人所分配角色进行处理
            for (let i = 0; i < this.loginUser.staffList.length; i++) {
                const res = await this.$app.getById('/base/orgTreeMgr/getOrganizationById', this.loginUser.staffList[i].orgFullId.split('-')[1])
                if (res.body.vo.passenger.HyglManager) {
                    arr.push(res.body.vo.passenger.HyglManager)
                }
            }
            var sss = this.vo.attendId.split('、')
            if (arr.length) {
                arr.forEach((item) => {
                    item.forEach((val) => {
                        var ccc = val.orgFullId.split('-')[1]
                        sss.forEach((res) => {
                            if (ccc === res) {
                                if (this.bumenid !== '') this.bumenid += ','
                                this.bumenid += res
                            }
                        })
                    })
                })
            }
            console.log('huoqu', this.bumenid)
        },
        addObjchange(val) {
            this.meetPersonType = null
            this.$nextTick(() => {
                this.meetPersonType = val
            })
        },
        rowClick(row) {
            console.log('点开议题', row)
            this.ytisShow = true
            this.$http({
                method: 'GET',
                params: {
                    busiDataIds: row.id
                },
                url: '/hygl/hyap/queryAttachList'
            }).then((result) => {
                if (result.code === 'success') {
                    this.listData = result.body.listdata
                } else {
                    this.$message.error(result.message)
                }
            })
        },
        rowClickyiti(row) {
            if (row.id) {
                var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadById?attachIds=' + row.id + '&httpPort=' + location.port
                window.open(attachurl, '_blank')
                // var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadByBusiDataId?busiDataId=' + row.id + '&httpPort=' + location.port
                // window.open(attachurl, '_blank')
            }
        },
        // 下载议题附件
        downloadFucYt(id, num) {
            if (num > 0) {
                var attachurl = process.env.VUE_APP_BASE_API + '/hygl/ytap/downloadByBusiDataId?busiDataId=' + id + '&httpPort=' + location.port
                window.open(attachurl, '_blank')
            }
        },
        // 下载会议题件
        downloadFuc(id, num) {
            var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadById?attachIds=' + id + '&httpPort=' + location.port
            window.open(attachurl, '_blank')
        },
        // 添加人员
        async savePeopleFuc() {
            if (!this.addObj.userName) {
                this.$confirm(this.$tx('hygl.message.selectPerson2', '请选择人员！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                // this.$message.error('请选择人员！')
                return false
            }
            if (!this.addObj.userDept) {
                this.$confirm(this.$tx('hygl.message.departNull', '部门不能为空！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                // this.$message.error('请选择人员！')
                return false
            }
            var re = /^1\d{10}$/ // 正则表达式
            // debugger
            if (!this.addObj.phone) {
                this.$confirm(this.$tx('hygl.message.phoneNull', '电话不能为空！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }
            if (!re.test(this.addObj.phone)) {
                this.$confirm(this.$tx('hygl.message.phoneInvalid', '人员电话无效，请输入11位手机号!'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
                return false
            }

            this.$set(this.addObj, 'meetId', this.meetingId)
            this.$set(this.addObj, 'meetPersonType', this.meetPersonType)
            // this.$set(this.addObj, 'regStatus', this.regStatus)
            // this.$set(this.addObj, 'meetPersonType', this.meetPersonType)
            const res = await this.$app.insert('/hygl/meetPeople/insert', this.addObj)
            if (res.code === 'success') {
                this.$message.success(res.message)
                this.innerVisible = false
                this.getPeople()
                // this.$bus.emit('refreshListData')
                this.addObj = {}
            } else {
                this.$message.error(res.message)
                this.innerVisible = false
            }
        },
        renyuanshuru(val) {
            this.disableds2 = false
            this.disableds1 = false
            this.disableds3 = false
            this.addObj.name = val
            this.$set(this.addObj, 'personId', val)
            // this.$set(this.addObj, 'regStatus', 1)
            this.addObj.regStatus = 1
            // this.meetPersonType = ''
            console.log('输入人', val)
        },
        bumen(val) {
            this.addObj.userDept = val
            console.log('输入部门', val)
        },
        dianhua(val) {
            this.addObj.phone = val
            console.log('输入电话', val)
        },
        zhiwei(val) {
            this.addObj.userPost = val
            console.log('输入职位', val)
        },
        closeclick() {
            this.innerVisible = false
            this.meetPersonType = '1'
            this.addObj = {
                regStatus: 1,
                remark: '',
                email: '',
                passenger: {},
                personId: '',
                userAccount: ''
            }
            // this.meetPersonType = ''
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                selected = node
            })
            this.disableds2 = true
            this.disableds1 = false
            this.disableds3 = false
            this.addObj.meetPersonType = '1'
            const num = selected.title.indexOf('\\')
            const dept = selected.title.substring(0, num)
            this.$set(this.addObj, 'userName', selected.name)
            this.$set(this.addObj, 'phone', selected.mobile)
            this.$set(this.addObj, 'userPost', selected.positionName)
            this.$set(this.addObj, 'userDept', dept)
            this.$set(this.addObj, 'email', selected.email)
            this.$set(this.addObj, 'userAccount', selected.account)
            this.$set(this.addObj, 'personId', selected.personId)
            this.addObj.regStatus = 0
            // this.$set(this.addObj, 'meetId', this.meetingId)
        },
        // tab切换
        handleClick(tab, event) {
            console.log(tab, event)
            if (tab.name === 'third') {
                this.getPeople()
            }
        },
        async initGetById(resultobj) {
            const res = await this.$app.getById('/hygl/hyap/getById', resultobj)
            if (res.code === 'success') {
                this.vo = res.body.vo
                if (this.vo.ytObject) {
                    this.tableData = JSON.parse(this.vo.ytObject)
                }
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取参会人员
        async getPeople() {
            const search = [
                {
                    compare: '=',
                    field: 'meetId',
                    merge: true,
                    value: this.meetingId
                }
            ]
            const res = await this.$app.querydata('/hygl/meetPeople/querydata', search, 'orgFullOrderNo asc')
            if (res.code === 'success') {
                this.tableDataPeople = res.body.listdata
                this.tableDataPeople.forEach((item) => {
                    this.peopleIds += item.personId + ','
                })
                this.peopleIds = this.peopleIds.substring(0, this.peopleIds.length - 1)
                this.$forceUpdate()
            } else {
                this.$message.error(res.message)
            }
        },
        // 删除参会人员
        async delChecked(index, row) {
            const arrIds = []
            arrIds.push(row.id)
            const res = await this.$app.deleteByIds('/hygl/meetPeople/delete', arrIds)
            if (res.code === 'success') {
                this.$message.success(res.message)
                this.getPeople()
                var reg1 = new RegExp(row.personId, 'g') // 加'g'，删除字符串里所有的"a"
                this.peopleIds = this.peopleIds.replace(reg1, '')
                this.$forceUpdate()
            } else {
                this.$message.error(res.message)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.el-dialog .el-dialog__body .el-tabs--top {
    margin-top: 0;
    height: 400px;
}
/deep/.el-table__empty-block {
    border-bottom: 1px solid #eeeeee;
}
/deep/.el-table .el-textarea__inner {
    height: 36px;
}
.hoverSpan {
    color: #409eff;
}
.hyryBox {
    /deep/ .el-table::before {
        content: none;
    }
}
/deep/ .el-table .warning-row {
    color: #409eff !important;
}
</style>
